import { Component, OnInit, ViewChild, ElementRef, Inject, AfterViewInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {SeoService} from '../../services/seo.service';
// import { SwiperComponent, SwiperDirective, SwiperModule, SwiperConfigInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-backing2',
  templateUrl: './backing2.component.html',
  styleUrls: ['./backing2.component.scss']
})
export class Backing2Component implements OnInit {

  SlideDisruption = {
    items: 1,
    dots: true,
    nav: true,
    margin: 0,
    stagePadding: 0
  };

  SlideOptions = {
    items: 3,
    dots: true,
    nav: false,
    margin: 0,
    stagePadding: 0,
    center: true,
    loop: false,
    responsiveClass:true,
    responsive:{
      2000:{
        items:4
      },
      1200:{
        items:3
      },
      700:{
        items:2
      },
      320:{
        items:1
      }
    }
  };

  slideParallax = {
    items: 1,
    dots: true,
    nav: false
  }

  // @ViewChild(SwiperComponent, { static: false }) swiper: SwiperComponent;
  @ViewChild('stepper') stepper: MatStepper;

  constructor( private title: Title, private seo: SeoService, private el: ElementRef) {
  }

  callback = (entries) => {
    document.querySelectorAll(".btn-v").forEach(element => {
      element.id.split("btn-")[1]
      element.addEventListener("click", () => {
      document.querySelector("#item-"+element.id.split("btn-")[1]).scrollIntoView({behavior: "smooth",block: "start", inline: "start"})
      })
    })

    /* entries.forEach((entry) => {
      const el = entry.target;
      let previousY = 0
      let previousRatio = 0

      if (entry.isIntersecting && !el.classList.contains('is-visible')) {
        console.log('visible')
        
      }
      const currentY = entry.boundingClientRect.y
      const currentRatio = entry.intersectionRatio
      const isIntersecting = entry.isIntersecting

      if (currentY < previousY) {
        console.log("Scrolling down")
        const el1 = this.el.nativeElement.querySelector('.target2');
        el1.classList.add( 'is-visible' );
      }else{
        const el1 = this.el.nativeElement.querySelector('.target2');
        el1.classList.remove( 'is-visible' );
      }
      

      previousY = currentY
      previousRatio = currentRatio
    }); */
  };

  ngOnInit(): void {

    const el1 = this.el.nativeElement.querySelector('.target1');



    const IO = new IntersectionObserver(this.callback, { threshold: 1 });
    IO.observe(el1);


    const t = 'gennius.xyz - Building Human-to-Human technologies';
    this.title.setTitle(t);

    this.seo.generateTags({
      title: 'gennius.xyz - Building Human-to-Human technologies',
      keyword: 'rewards, cryptocurrencies, crypto, cashback, points, miles, digital card, digital payment, loyalty rewards, redemptions, digital assets, bank cards, bank directs, smart payments, virtual card, metaverse, NFT',
      // tslint:disable-next-line:max-line-length
      description: "Empowering rewards and Web3 platforms to create superior user experiences and bring digital engagement and loyalty to new levels.",
      image: 'https://gennius.xyz/assets/img/gennius/share-gennius.jpg'
    });

    /* const canvas = document.getElementById('canvas3d') as HTMLCanvasElement;
    const app = new Application(canvas);
    app.load('https://prod.spline.design/mEn50a1O-N9ETRqD/scene.splinecode'); */



  }

  Navigate(elem: HTMLElement) {
    elem.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    const headers = this.el.nativeElement.querySelectorAll('.mat-step-header');
    const icon = this.el.nativeElement.querySelectorAll('.mat-step-icon');
    const label = this.el.nativeElement.querySelectorAll('.mat-step-label');
    headers[0].style.pointerEvents = 'none';
    headers[1].style.pointerEvents = 'none';
    icon[1].classList.add('mat-step-icon-selected')
    label[1].classList.add('mat-step-label-selected')
  }

  selectionChange(index){
    const headers = this.el.nativeElement.querySelectorAll('.mat-step-header');
    const icon = this.el.nativeElement.querySelectorAll('.mat-step-icon');
    const label = this.el.nativeElement.querySelectorAll('.mat-step-label');

    for (var x of headers) {
      x.style.pointerEvents = 'auto';
    }

    for (var val of icon) {
      val.classList.remove('mat-step-icon-selected');
    }

    for (var i of label) {
      i.classList.remove('mat-step-label-selected');
    }

    if(index.selectedIndex == 0){
      icon[1].classList.add('mat-step-icon-selected')
      label[1].classList.add('mat-step-label-selected')
      headers[0].style.pointerEvents = 'none';
      headers[1].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 1){
      icon[0].classList.add('mat-step-icon-selected')
      label[0].classList.add('mat-step-label-selected')
      headers[0].style.pointerEvents = 'none';
      headers[1].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 2){
      icon[3].classList.add('mat-step-icon-selected')
      label[3].classList.add('mat-step-label-selected')
      headers[2].style.pointerEvents = 'none';
      headers[3].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 3){
      icon[2].classList.add('mat-step-icon-selected')
      label[2].classList.add('mat-step-label-selected')
      headers[2].style.pointerEvents = 'none';
      headers[3].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 4){
      icon[5].classList.add('mat-step-icon-selected')
      label[5].classList.add('mat-step-label-selected')
      headers[4].style.pointerEvents = 'none';
      headers[5].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 5){
      icon[4].classList.add('mat-step-icon-selected')
      label[4].classList.add('mat-step-label-selected')
      headers[4].style.pointerEvents = 'none';
      headers[5].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 8){
      icon[9].classList.add('mat-step-icon-selected')
      label[9].classList.add('mat-step-label-selected')
      headers[8].style.pointerEvents = 'none';
      headers[9].style.pointerEvents = 'none';
    }else if(index.selectedIndex == 9){
      icon[8].classList.add('mat-step-icon-selected')
      label[8].classList.add('mat-step-label-selected')
      headers[8].style.pointerEvents = 'none';
      headers[9].style.pointerEvents = 'none';
    }
  }

  viewMore(number){
    const content = this.el.nativeElement.querySelectorAll('.more');
    const links = this.el.nativeElement.querySelectorAll('.view-more');
    const link = this.el.nativeElement.querySelectorAll('.view-less');

    for (const [index, value] of content.entries()) {
      if(index == number){
        value.style.display = "inline";
      }
    }

    for (const [i, val] of links.entries()) {
      if(i == number){
        val.style.display = "none";
      }
    }

    for (const [i, val] of link.entries()) {
      if(i == number){
        val.style.display = "inline";
      }
    }

  }

  viewLess(number){
    const content = this.el.nativeElement.querySelectorAll('.more');
    const link = this.el.nativeElement.querySelectorAll('.view-more');
    const links = this.el.nativeElement.querySelectorAll('.view-less');

    for (const [index, value] of content.entries()) {
      if(index == number){
        value.style.display = "none";
      }
    }

    for (const [i, val] of links.entries()) {
      if(i == number){
        val.style.display = "none";
      }
    }

    for (const [i, val] of link.entries()) {
      if(i == number){
        val.style.display = "inline";
      }
    }

  }

}
